import { useEffect, useState } from 'react'

const useSendBoxRef = (instanceId?: string): HTMLTextAreaElement | null => {
  const [current, setCurrent] = useState<HTMLTextAreaElement | null>(null)

  const handleChange = (e: CustomEvent): void => {
    if (instanceId) {
      e.detail.instanceId === instanceId && setCurrent(e.detail.value)
    } else {
      setCurrent(e.detail.value)
    }
  }

  useEffect(() => {
    document.addEventListener('retorik_sendBoxRef', (e) => handleChange(e))
    // Dispatch event on mount to get the updated value in stead of the default one
    document.dispatchEvent(new Event('retorik_call_sendBoxRef'))

    return () => {
      document.removeEventListener('retorik_sendBoxRef', (e) => handleChange(e))
    }
  }, [])

  return current
}

export default useSendBoxRef
